import { myInput } from '../input.js';
import { cameras } from '../view/cameras.js';
import { historie } from '../history.js';
import { userimage } from '../tools/userimage.js';
import { myToolbar } from '../tools/toolbar.js';
import { guides } from '../view/guides.js';
import { patterns } from '../patterns/patterns.js';
import { project } from '../projects/project.js';
import { save } from '../projects/save.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { palette } from '../palette.js';
import { migrate } from '../procedures/migrate.js';
import { beadCloud } from './azure.js';
import { db } from './db.js';
import { exp } from '../export/export.js';
import '../export/brick';
import '../export/diagrams';
import '../export/editor';
import '../export/image';
import '../export/medallion';
import '../export/peyote';
import '../export/squareAndStar';
import '../export/triangle';
import '../export/wordChart';

export const start = {};

// called by main Phaser config (create)
export const create = () => {
    [
        project, cameras, myInput, myToolbar, userimage,
        beads, palette, guides,
    ].forEach(obj => obj.initialize());
};

// check if need to migrate from v2 to v3
const checkIfUserMustMigrate = async () => {
    if (!loggedIn) return false;
    let legacySettings;
    try {
        legacySettings = await db.settings.get(1);
    } catch (error) {
        console.info('Could not open indexedDB');
    }
    if (typeof legacySettings === 'object') { // we have saved settings
        if (!legacySettings.hasMigrated) { // we have not yet migrated to v3
            return true;
        }
    }
    return false;
};

const blankUserDoc = {
    id: currentUserId,
    units: 'inch',
    enableMouseScroll: true,
    theme: 'Auto',
    favorites: [],
    footer: '',
    pageSize: 'Letter',
    defaultPaletteID: null,
    collections: [],
    customBeads: [],
    templates: []
};

const createNewUserDoc = async () => {
    const recordObj = blankUserDoc;
    await beadCloud({
        fn: 'saveToCloud',
        params: {recordObj, container: 'users'}
    });
    return recordObj;
};

const createOrLoadUserDoc = async () => {
    if (!loggedIn) return blankUserDoc;
    let myUserDoc = await beadCloud({
        fn: 'getItemFromId',
        params: {
            id: currentUserId, 
            container: 'users'
        }
    });

    // create user doc if none exists
    if (!myUserDoc || myUserDoc.error) {
        myUserDoc = await createNewUserDoc();
    }

    return {
        id: myUserDoc.id,
        units: myUserDoc.units,
        enableMouseScroll: myUserDoc.enableMouseScroll,
        theme: myUserDoc.theme,
        favorites: myUserDoc.favorites,
        footer: myUserDoc.footer,
        pageSize: myUserDoc.pageSize,
        defaultPaletteID: myUserDoc.defaultPaletteID,
        collections: myUserDoc.collections || [],
        customBeads: myUserDoc.customBeads || [],
        templates: myUserDoc.templates || []
    };
};

// user clicks 'Start Beading' button
start.beading = async () => {
    const mustMigrate = await checkIfUserMustMigrate();
    if (mustMigrate) {
        migrate();
        return;
    }
    settings.preferences = await createOrLoadUserDoc();

    settings.setTheme(settings.preferences.theme);
    b3.store.mySet('defaultPaletteID', settings.preferences.defaultPaletteID);
    b3.store.mySet('collections', settings.preferences.collections);
    b3.store.mySet('customBeads', settings.preferences.customBeads);
    b3.store.mySet('templates', settings.preferences.templates);

    const tabToGo = loggedIn ? 'File' : 'Edit';
    b3.store.mySet('currentTab', tabToGo);
    b3.store.mySet('currentScreen', 'menu');
    if (loggedIn) {
        b3.ee.emit('myProjectsActivated');
        if (!start.hasSeenNews()) {
            b3.store.mySet('showingModal', 'news');
        }
    } else {
        b3.store.mySet('showingModal', 'new');
    }
    myInput.enableTyping();
};

start.hasSeenNews = () => {
    const relevantCookie = document.cookie
        .split(';')
        .map(str => str.trim())
        .map(str => ({
            key: str.split('=')[0],
            value: str.split('=')[1]
        }))
        .filter(obj => obj.key === 'b3readnews2')
    
    if (!relevantCookie[0]) return false;
    return (relevantCookie[0]?.value === 'yes');
};


// called by load.project and NewProject.vue
start.newProject = config => {
    b3.ee.emit('newProject');
    [
        settings, userimage, beads, historie, palette,
        patterns, cameras, myInput, guides, save
    ].forEach(obj => obj.newProject(config));
};
